import React from "react";
import { Text, View } from "@react-pdf/renderer";
import { withNamespaces } from "react-i18next";

import {
    getKybReportChildId,
    isSupportedKybReportSource,
    resolveKybReportSource,
} from "src/modules/3rd-party-management/helpers/kybReports";

import styles from "../../styles";
import { ExternalReportSummary, KeyValueTable, SectionTitle, SubSectionTitle } from "../../shared";
import DunBradstreetReport from "./DunBradstreetReport";
import DunBradstreetEnterpriseReport from "./DunBradstreetEnterpriseReport";
import HandelsregisterReport from "./HandelsregisterReport";

const renderReportBody = ({ t, source, report }) => {
    if (source === "dun_brad_street") {
        return <DunBradstreetReport report={report} />;
    }

    if (source === "dun_brad_street_enterprise") {
        return <DunBradstreetEnterpriseReport report={report} />;
    }

    if (source === "handelsregister") {
        return <HandelsregisterReport report={report} />;
    }

    if (isSupportedKybReportSource(source)) {
        return (
            <Text style={styles.wordOverviewBody}>
                {t("Provider report content will appear in this section.")}
            </Text>
        );
    }

    return (
        <Text style={styles.wordOverviewBody}>
            {t("This provider report is not included in the PDF export.")}
        </Text>
    );
};

const ExternalProviderReportsSection = ({ t, supplierData = {}, meta }) => {
    const kybReports = Array.isArray(supplierData?.kybReports)
        ? supplierData.kybReports
        : [];
    const child = meta?.child || {};

    return (
        <View style={styles.wordSectionContent}>
            {kybReports.length === 0 ? (
                <KeyValueTable
                    leading={(
                        <SectionTitle
                            title={meta?.title || "External Provider Reports"}
                            number={meta?.number}
                            anchorId={meta?.anchorId}
                        />
                    )}
                    rows={[]}
                    emptyMessage="No external provider reports available"
                    titleColumnLabel="Report"
                    detailsColumnLabel="Details"
                />
            ) : (
                kybReports.map((report, index) => {
                    const source = resolveKybReportSource(report);
                    const childMeta = child[getKybReportChildId(index)] || {};

                    return (
                        <View key={report?.id || `${source || "report"}-${index}`}>
                            <View wrap={false} minPresenceAhead={260}>
                                {index === 0 ? (
                                    <SectionTitle
                                        title={meta?.title || "External Provider Reports"}
                                        number={meta?.number}
                                        anchorId={meta?.anchorId}
                                    />
                                ) : null}
                                <SubSectionTitle
                                    title={childMeta.title || `Provider Report ${index + 1}`}
                                    number={childMeta.number}
                                    anchorId={childMeta.anchorId}
                                />
                                <ExternalReportSummary report={report} />
                            </View>

                            {renderReportBody({ t, source, report })}
                        </View>
                    );
                })
            )}
        </View>
    );
};

export default withNamespaces()(ExternalProviderReportsSection);
